import {
  IconUser,
  IconUsers,
  IconLayoutDashboard,
  IconBulb,
  IconCalendar,
  IconCalendarEvent,
  IconCurrencyDollar,
  IconStar,
  IconMoneybag,
  IconStethoscope,
  IconChartBar,
  IconMail,
  IconNews,
  IconScale,
} from "@tabler/icons-react";

interface IRouteProps {
  path: string;
  icon: typeof IconUser;
  label: string;
}

export const routes: IRouteProps[] = [
  { path: "/d", icon: IconLayoutDashboard, label: "Overview" },
  {
    path: "/d/analytics",
    icon: IconChartBar,
    label: "Analytics",
  },
  { path: "/d/tips", icon: IconBulb, label: "Tips" },
  { path: "/d/testimonials", icon: IconStar, label: "Testimonials" },
  { path: "/d/newsletter", icon: IconUsers, label: "Newsletter" },
  { path: "/d/uwip", icon: IconScale, label: "U-WIP Members" },
  { path: "/d/emails", icon: IconMail, label: "Emails" },
];
